import { SET_TESTIMONIAL } from "../actions";

const testimonial = (state = [], action) => {
  switch (action.type) {
    case SET_TESTIMONIAL:
      return [...action.value];
    default:
      return state;
  }
};

export default testimonial;
